import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import CustomIcon from "../CustomIcon";
import { Button } from "reactstrap";
import "./index.css";

/**
 * Renders an icon based on the provided icon state and group.
 * @param {Object} props - The component props.
 * @param {string} props.iconState - The state of the icon.
 * @param {Array} props.iconGroup - The group of the icon.
 * @returns {React.ReactNode} The rendered icon or null.
 */
const RenderIcon = ({ iconState, iconGroup }) => {
  return iconState && iconGroup ? <CustomIcon status={iconState} iconGroup={iconGroup} /> : null;
};

RenderIcon.propTypes = {
  iconState: PropTypes.string,
  iconGroup: PropTypes.node
};

/**
 * Renders an underlined text button.
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the button.
 * @param {Function} props.onClick - The click event handler.
 * @param {Object} props.style - The additional style object for the button.
 * @returns {JSX.Element} The rendered underlined text button.
 */
export const UnderlinedTextButton = (props) => {
  let { title, onClick, style } = props;
  return (
    <Fragment>
      <button className="general-button-underlined grey" onClick={onClick} style={style}>
        <RenderIcon {...props} />
        {title}
      </button>
    </Fragment>
  );
};

UnderlinedTextButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

/**
 * Renders a pill-shaped text button.
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the button.
 * @param {Function} props.onClick - The click event handler.
 * @param {Object} props.style - The additional style object for the button.
 * @returns {JSX.Element} The rendered pill-shaped text button.
 */
export const PillTextButton = (props) => {
  let { title, onClick, style } = props;
  return (
    <Fragment>
      <button className="general-button-pill non-toggleAble" style={style} onClick={onClick}>
        <RenderIcon {...props} />
        {title}
      </button>
    </Fragment>
  );
};

PillTextButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

/**
 * Renders a toggle-able pill-shaped text button.
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the button.
 * @param {Function} props.onClick - The click event handler.
 * @param {boolean} props.state - The state of the button.
 * @param {boolean} props.latch - The latch behavior of the button.
 * @returns {JSX.Element} The rendered toggle-able pill-shaped text button.
 */
export const PillTextButtonToggleAble = (props) => {
  let { title, onClick, state, latch } = props;
  return (
    <Fragment>
      <button
        className={`general-button-pill toggleAble ${state ? "pressed" : "released"} ${latch ? "latch-behavior" : ""}`}
        onClick={onClick}
      >
        <RenderIcon {...props} />
        {title}
      </button>
    </Fragment>
  );
};

PillTextButtonToggleAble.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  state: PropTypes.bool,
  latch: PropTypes.bool,
}
  ;
/**
  Renders a hyperlink-style text button.
*@param {Object} props - The component props.
*@param {string} props.title - The title of the button.
*@param {Function} props.onClick - The click event handler.
*@param {Object} props.style - The additional style object for the button.
*@returns {JSX.Element} The rendered hyperlink-style text button.

*/

export const HyperlinkTextButton = (props) => {
  let { title, onClick, style } = props;
  return (
    <Fragment>
      <button className="general-button-underlined file-hyperlink" onClick={onClick} style={style}>
        <RenderIcon {...props} />
        {title}
      </button>
    </Fragment>
  );
};

HyperlinkTextButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

/**

Renders a simple button.
*@param {Object} props - The component props.
*@param {string} props.title - The title of the button.
*@param {Function} props.onClick - The click event handler.
*@param {boolean} props.disabled - Indicates if the button is disabled.
*@returns {JSX.Element} The rendered simple button.
*/
export const SimpleButton = ({ title, onClick, disabled }) => {
  return (
    <Button
      style={{
        height: "30px",
        minWidth: "100px",
        backgroundColor: "rgb(255, 255, 255)",
        color: "rgb(26, 26, 26)",
        fontSize: "12px",
        cursor: "pointer",
        borderRadius: "0px",
        transitionDuration: "0.4s",
        fontWeight: "bold",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

SimpleButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/libraries/GeneralButtons/index.jsx